<template>
  <div
    v-if="notMobileLogin"
    class="w-full bg-zt-white rounded-zt-md overflow-hidden"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center p-6" v-if="isComponentVisible">
      <div
        class="mb-4 flex justify-center"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : '']"
        :style="boxLogin.sizeLogo !== 'full' ? 'width: 196px' : ''"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>
      <div class="w-full" v-if="loginErrors.showMessage">
        <zt-alert
          :text="loginErrors.message"
          color="danger"
          :duration="loginErrors.MAX_DURATION_ALERT"
          @afterClosed="loginErrors.showMessage = false"
        />
      </div>
      <div class="mt-4 w-full">
        <ValidationObserver v-slot="{ invalid }">
          <zt-auth-login-fields
            v-model="loginFields"
            :login-custom-params-fields="boxLogin"
            @activeButton="fieldActiveButton(invalid)"
          />
          <div class="w-full text-left text-zt-md mb-10">
            <router-link
              :to="{ name: 'forgotPassword' }"
              class="zt-link-forgot-pass text-zt-primary-200"
              :style="[boxLogin.styles.form.textColor]"
              >{{
                $t('message.loginComponent.login.forgetPassword')
              }}</router-link
            >
          </div>
          <div class="mb-4">
            <zt-button
              class="zt-button-login w-full opacity-100"
              :style="[bgButtonColor(invalid)]"
              :disabled="invalid || isDisabledButton"
              @click="submitLogin"
              data-vs-button="auth-login-btn-submitlogin"
            >
              <span v-if="!isLoadingLogin">
                {{ $t('message.loginComponent.login.logintext') }}
              </span>
              <vue-loading
                v-if="isLoadingLogin"
                background-color="rgba(0,0,0,0.0)"
                :active="isLoadingLogin"
                color="#4F41A3"
                :width="30"
                :height="30"
                :is-full-page="false"
              />
            </zt-button>
          </div>
          <div class="flex justify-center" v-if="showButtonSSO">
            <zt-button
              class="zt-button-sso w-full"
              style="background-color: #84afda"
              @click="gotoSSO"
              data-vs-button="auth-login-btn-gotosso"
            >
              {{ $t('message.loginComponent.sso.textButton') }}
            </zt-button>
          </div>

          <div class="flex justify-center" v-if="hasIntegrationSichernConnect">
            <button
                type="button"
                class="sichern-connect h-16 zt-white border border-zt-dark-300 w-full rounded text-zt-base"
                @click.prevent="getSichernConnectURL"
            >
              <span class="items-center justify-center mr-2 inline-block align-middle">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path d="M10.3201 7.63867C13.1529 7.9054 16.2374 9.37652 18.0002 11.5818C20.2662 14.323 19.5096 17.0653 16.2374 17.7319C13.0267 18.4004 8.55733 16.6607 6.29092 13.9213C4.59127 11.8499 4.59127 9.70967 6.16508 8.57383L15.1042 15.5924L10.3201 7.63867Z" fill="#FF0540"/>
                </svg>
              </span>
      
              {{ $t('message.loginComponent.login.login_text_sichern_connect') }}
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <div class="w-full text-zt-warning lg:block" v-if="isComponentVisible">
      <zt-auth-login-commercial-help
        :first-login-custom-params-fields="boxLogin"
      />
    </div>
  </div>
  <div v-else class="flex flex-col justify-center items-center">
    <div
      class="mb-4 flex justify-center"
      style="width: 196px"
    >
      <img class="format-img" :src="boxLogin.logoUrl" alt="" />
    </div>
    <div class="relative w-full h-40">
      <loader v-if="loadingBiometric" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { filter, find, map, isEmpty, isEqual } from 'lodash'
import ZtAuthLoginFields from '@/modules/Auth/components/authLoginFields'
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import Auth from '@/apiClient/Auth'
import Users from '@/apiClient/Users'
import Mfa from '@/apiClient/Mfa'
import ZtAuthLoginCommercialHelp from '@/modules/Auth/components/authLoginCommercialHelp'
import apiCodes from '@/modules/Auth/constant/constant.js'
import moment from 'moment'
import URLQueryString from '@/utils/queryString'
import SichernIntegration from '@/apiClient/SichernIntegration';
import Loader from '@/modules/Auth/components/loader'
export default {
  name: 'ztLogin',
  components: { ZtAuthLoginCommercialHelp, ZtAuthLoginFields, Loader },
  inject: ['mutationUser', 'mutationUserPass'],
  data() {
    return {
      objectLoginParams: {},
      loginFields: {
        userName: '',
        userPass: ''
      },
      isLoadingLogin: false,
      isDisabledButton: false,
      jwt: '',
      usersEmployeeRelated: [],
      userRelatedEmpty: false,
      userEmployee: {},
      loginErrors: {
        message: '',
        showMessage: false,
        MAX_DURATION_ALERT: 4
      },
      codePasswordExpired: false,
      queryParamsSAML: null,
      hasIntegrationSichernPeople: false,
      loadingBiometric: false,
      isComponentVisible: false,
      isInIframe: false,
      hasIntegrationSichernConnect: false
    }
  },
  mixins: [loginCustomParams],
  computed: {
    ...mapGetters({ getLoginCustomParams: 'auth/getLoginCustomParams', getFactoryStringParam: 'auth/getFactoryStringParam' }),
    bgButtonColor() {
      return invalid =>
        invalid
          ? { backgroundColor: '#E2E2E2' }
          : this.boxLogin.styles.form.buttons.bgColor
    },
    showButtonSSO() {
      return typeof this.boxLogin.styles.form.buttonSSO.showButton !==
        'undefined' && this.boxLogin.styles.form.buttonSSO.showButton !== ''
        ? this.boxLogin.styles.form.buttonSSO.showButton
        : false
    },
    hasParamsSAML() {
      return status =>
        isEqual(status, 200) &&
        this.queryParamsSAML.has('SAMLRequest') &&
        this.queryParamsSAML.has('RelayState')
    },
    notMobileLogin() {
      const { deviceId, deviceToken } = this.$route.query
      return !deviceId && !deviceToken
    },
    performanceToken() {
      return this.$iframeMessages.getTokenPerformanceValue();
    },
    isAutoLogin() {
      return this.performanceToken && !this.loginFields.userName && !this.loginFields.userPass
    }
  },
  methods: {
    ...mapActions({
      setJWT: 'setJwt',
      setCheckUserEmployee: 'setCheckUserEmployee',
      setUsersRelated: 'setUsersRelated',
      getProfile: 'getProfile',
      getUserRelated: 'getUserRelated',
      getProfileByIdPatchUserRelated: 'getProfileByIdPatchUserRelated',
      setActions: 'setActions',
      setStateNotOnBoarding: 'setStateNotOnboarding',
      setUser: 'setUser',
      setParamLoginFactory: 'auth/setParamLoginFactory',
      setHasIntegrationSichernPeople: 'setHasIntegrationSichernPeople',
      setHasIntegrationSichernConnect: 'setHasIntegrationSichernConnect',
      clearState: 'clearState',
      setPayrollStatus: 'setPayrollStatus',
      setLinkKeycloakResult: 'setLinkKeycloakResult'
    }),
    async performAutoLogin(performanceToken) {
      // Marcar que viene de auto-login para omitir validaciones de campos
      this.loginFields.userName = ''
      this.loginFields.userPass = ''
      
      // Reutilizar submitLogin
      await this.submitLogin()
      
      // Notificar al layout que oculte el loading
      this.$root.$emit('hide-layout-loading')
    },
    async submitLogin() {
      this.isLoadingLogin = true
      this.isDisabledButton = true
      try {
        // Si hay performanceToken y no hay credenciales, es auto-login
        const userParam = this.isAutoLogin ? null : this.loginFields.userName.trim().toLowerCase()
        const userPass = this.isAutoLogin ? null : this.loginFields.userPass
        const performanceToken = this.isAutoLogin ? this.performanceToken : null

        const response = await (this.hasIntegrationSichernConnect ? this.auth.loginForConnect(
          userParam,
          userPass
        ) : await this.auth.login(
          userParam,
          userPass,
          performanceToken
        ))

        const {
          data: { jwt, code },
          status
        } = response
        this.jwt = jwt
        this.setJWT({ jwt: this.jwt })
        if (this.hasParamsSAML(status)) {
          await this.accessSAML()
          return
        } else {
          await this.loginSuccess(code)
        }
        this.isDisabledButton = false
      } catch (error) {
        this.handleErrors(error)
      }
    },
    async loginSuccess(code, toMobileSuccess) {
      const { factory } = this.$route.query
      this.$iframeMessages.setAuthenticated(true)
      let userRelatedEmpty = await this.getListUserRelated()
      if (userRelatedEmpty) return this.handleErrors('errAccessRRHH')  
      if(factory) {
        //TODO no olvidar que esto es temporal, se debe eliminar cuando se implemente el login y el ruteo con v3
        localStorage.setItem('factory', factory)
        await this.setUserEmployeeByFactory(factory)
      } else {
        await this.setUserEmployee()
      }
      if (
        code && code === apiCodes.MFA_EMAIL_VERIFICATION ||
        code && code === apiCodes.MFA_CODE_VERIFICATION
      )
      return this.redirectToMFA(code)
      if (code && code === apiCodes.FIRST_LOGIN) return this.verifyFirstLogin()
      if (this.codePasswordExpired === apiCodes.PASSWORD_EXPIRED)
      return this.verifyPasswordExpired()
    if (this.userEmployee.estado_empresa === 2) {
      return this.verifyUserOnBoarding()
    }
    // await this.checkActiveSichernPeopleIntegration();
    // await this.setPayrollStatus();
        // Solo vincular con Falabella si viene de allí
    const falabellaJWT = window.localStorage.getItem('__EXTERNAL_FALABELLA_JWT__')
    if (falabellaJWT) {
      await this.linkKeycloak(falabellaJWT)
    }
    await this.authorizedAccess(toMobileSuccess)
    },
    fieldActiveButton(invalid) {
      if (!invalid) this.submitLogin()
    },
    async getListUserRelated() {
      try {
        let listUserRelated = await this.getUserRelated()
        this.usersEmployeeRelated = filter(listUserRelated, userRelated =>
          find(userRelated.perfiles, profile => profile.id_perfil_tipo === 1)
        )
        if (isEmpty(this.usersEmployeeRelated)) {
          return true
        }
        this.userEmployee = this.findDateLastSessionUser(this.usersEmployeeRelated)
        await this.setCheckUserEmployee(true)
        await this.setUsersRelated({
          usersRelated: this.usersEmployeeRelated
        })
      } catch (error) {
        this.handleErrors(error)
      }
    },
    findDateLastSessionUser(listUserRelated) {
      let userListToLogin = listUserRelated.filter(userRelated => !userRelated.blockedByPayment)
      let userWithOutLastSession = find(userListToLogin, userRelated =>
        isEmpty(userRelated.ultimasession)
      )
      let LastSessionUser = new Date(
        Math.max.apply(
          null,
          map(userListToLogin, userLastSession => {
            if (!isEmpty(userLastSession.ultimasession)) {
              return new Date(
                moment(
                  userLastSession.ultimasession,
                  'DD-MM-YYYY hh:mm:ss'
                ).format()
              )
            } else return ''
          })
        )
      )
      let userWithLastSession = filter(
        userListToLogin,
        userWithLastSession =>
          new Date(
            moment(
              userWithLastSession.ultimasession,
              'DD-MM-YYYY hh:mm:ss'
            ).format()
          ).getTime() === LastSessionUser.getTime()
      )[0]
      return userWithOutLastSession
        ? userWithOutLastSession
        : userWithLastSession
    },
    async setUserEmployee() {
      try {
        const {
          data: { code }
        } = await this.getProfileByIdPatchUserRelated(this.userEmployee.id)

        this.codePasswordExpired = code
        this.setUser({ user: this.userEmployee })
      } catch (error) {
        this.handleErrors(error)
      }
    },
    verifyFirstLogin() {
      this.$router.push({ name: 'firstLogin' })
    },
    verifyPasswordExpired() {
      this.mutationUserPass.setPExpired(this.loginFields.userPass)
      this.$router.push({ name: 'passwordExpired' })
    },
    verifyUserOnBoarding() {
      localStorage.setItem('jwt', this.$store.getters.getJwt)
      location.replace(
        window.location.origin + '/s/home/' + this.$store.getters.getUser.id
      )
      this.$store.dispatch('clearState')
    },
    async authorizedAccess(toMobileSuccess) {
      try {
        await this.setActions()
        await this.setStateNotOnBoarding(true)
        const { so } = this.$route.query
        if ((so && ['androidOS','iOS'].includes(so)) || toMobileSuccess) {
          await this.$router.push({ name: 'mobileLoginSuccess' })
          this.isLoadingLogin = false
          return
        } else {
          const isManagerRole = this.$store.state.user.perfiles.some(objeto => objeto.id_perfil_tipo === 8);
          const targetRoute = '/v3/'
          // Verificar si el token del iframe es válido
          const iframeTokenValid = this.$iframeMessages.isTokenValid(); 
   
          if(iframeTokenValid){
            // Redirigir a licencias según el rol (igual lógica que MenuBar)
            const actions = this.$store.state.actions || [];
            const actionsIds = actions.map(action => action.id);
            const isApprover = actionsIds.includes('71');
            const isEmployee = actionsIds.includes('72');
            
            if (isApprover) {
              await this.$router.push({ name: 'licensesManager' })
            } else if (isEmployee) {
              await this.$router.push({ name: 'licenses' })
            } else {
              await this.$router.push({ name: 'licenses' })
            }
          }else {
            await this.$router.push(targetRoute)
          }
          

        }
        this.isLoadingLogin = false
      } catch (error) {
        this.handleErrors(error)
      }
    },
    handleErrors(error) {
      try {
        // Detectar si es un auto-login fallido
        if (this.isAutoLogin && this.isInIframe) {
          // Usar el handler para notificar el error
          this.$iframeMessages.sendAutoLoginError(error)
          
          // Ocultar el loading del layout
          this.$root.$emit('hide-layout-loading')
          
          this.isLoadingLogin = false
          this.isDisabledButton = false
          return
        }
        
        const hasResponse = error && error.response && error.response.data;
        const responseData = hasResponse ? error.response.data : null;
        
        if (responseData && responseData.code === '00018') {
          this.setStateNotOnBoarding(true)
          this.mutationUser.setUBlock(this.loginFields.userName)
          this.mutationUser.setPBlock(this.loginFields.userPass)
          this.$router.push({ name: 'userBlock' })
          return
        }
        if (responseData && responseData.code === '00151') {
          this.isLoadingLogin = false
          this.isDisabledButton = false
          this.loginErrors.showMessage = true
          this.loginErrors.message = responseData.message || this.$t(
            `message.errorReference.${responseData.code}`
          )
          this.$store.dispatch('clearState')
          return
        }
        
        this.isLoadingLogin = false
        this.isDisabledButton = false
        this.loginErrors.showMessage = true
        
        let errorCode = '00001'; // Default: Usuario y/o contraseña incorrectos.
        if (typeof error === 'string') {
          errorCode = error;
        } else if (responseData) {
          if (responseData.code) {
            errorCode = responseData.code;
          } else if (responseData.response_v2 && responseData.response_v2.code) {
            errorCode = responseData.response_v2.code;
          }
        }
        
        this.loginErrors.message = this.$t(`message.errorReference.${errorCode}`)
        this.$store.dispatch('clearState')
      } catch (e) {
        this.loginErrors.showMessage = true
        this.loginErrors.message = this.$t(`message.errorReference.00003`)
        this.isLoadingLogin = false
        this.isDisabledButton = false
        this.$store.dispatch('clearState')
      }
    },
    gotoSSO() {
      let baseUrl = location.origin
      location.replace(baseUrl + '/sso')
    },
    accessSAML() {
      this.$router.push({
        name: 'authSAML',
        params: { queryParamsSAML: this.queryParamsSAML }
      })
    },
    redirectToMFA(code) {
      let email = this.$store.getters.getUser.mail
      if (code === apiCodes.MFA_EMAIL_VERIFICATION) {
        this.$router.push({
          name: 'mfaEmailVerification',
          params: { email: email, password: this.loginFields.userPass }
        })
      }
      if (code === apiCodes.MFA_CODE_VERIFICATION) {
        this.MFA.getResendStatus()
          .then(() => {
            this.$router.push({
              name: 'mfaUserBlock'
            })
          })
          .catch(() => {
            this.$router.push({
              name: 'mfaCodeVerification',
              params: { email: email }
            })
          })
      }
    },
    async setUserEmployeeByFactory(factory) {
      try {
        this.setParamLoginFactory(factory)
        this.userEmployee = find(this.usersEmployeeRelated, user => {
          return user.empresa.id === parseInt(factory, 10)
        })
        const {
          data: { code }
        } = await this.getProfileByIdPatchUserRelated(this.userEmployee.id)
        this.codePasswordExpired = code
        this.setUser({ user: this.userEmployee })
      } catch (error) {
        this.handleErrors(error)
        await this.$router.push({name: 'login'})
      }
    },
    async checkActiveSichernPeopleIntegration() {
      const type = 'VP_ABSENCES_HOLIDAYS'
      try {
        const res = await this.vi.checkIntegrationSichernPeople(type)
        this.hasIntegrationSichernPeople = res.data.data.enabled;
        this.setHasIntegrationSichernPeople(this.hasIntegrationSichernPeople);
      } catch (error) {
        console.error('Error checking Sichern People integration:', error);
        this.setHasIntegrationSichernPeople(false);
      }
    },
    async checkActiveSichernConnectIntegration() {
      this.hasIntegrationSichernConnect = false;
      this.setHasIntegrationSichernConnect(false);
    },
    async onRequestSuccess({ DeviceToken, jwt, status }) {
      localStorage.setItem('deviceToken', DeviceToken)
      localStorage.setItem('jwt', jwt)
      this.setJWT({ jwt: jwt })
      if (this.hasParamsSAML(status)) {
        await this.accessSAML()
      } else {
        await this.loginSuccess(null, true)
      }
    },
    onResponseError(error) {
      const errorCode =
        !isEmpty(error.response.data) && 'codes' in error.response.data
          ? error.response.data.codes[0].code
          : error.response.status
      localStorage.removeItem('deviceToken')
      localStorage.removeItem('jwt')
      this.setJWT({ jwt: '' })
      this.clearState()
      this.$router.push({
        name: 'login',
        query: {
          authfailed: errorCode
        }
      })
    },
    async linkKeycloak(falabellaJWT) {
      try {
        const response = await this.user.linkKeycloak(falabellaJWT)
        if (response.status === 201) {
          this.setLinkKeycloakResult('success')
        }
      } catch (error) {
        console.log('error', error);
        this.setLinkKeycloakResult('error')
      } finally {
        window.localStorage.removeItem('__EXTERNAL_FALABELLA_JWT__')
      }
    },
    getSichernConnectURL() {
      window.location.href = window.location.origin + '/sichern-connect';
    }
  },
  mounted() {
    this.queryParamsSAML = new URLQueryString(window.location.search)
    if (this.isInIframe) {
      setTimeout(() => {
        this.isComponentVisible = true;
      }, 1000);
      
      // Observar cambios en el performanceToken para auto-login
      this.$watch(
        () => this.performanceToken,
        (newValue) => {
          if (newValue && this.isInIframe) {
            // Ejecutar login automático con el performanceToken
            this.performAutoLogin(newValue)
          }
        },
        { immediate: true }
      )
    }
  },
  async created() {
    this.auth = new Auth()
    this.user = new Users()
    this.MFA = new Mfa()
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
    this.vi = new SichernIntegration();
    // Detectar iframe ANTES del await: dentro del iframe (integración Mandü)
    // el login es por performanceToken vía postMessage, no aplica SichernConnect.
    // Llamar a checkDomain() acá colgaba el created() y rompía el handshake del iframe.
    this.isInIframe = window.self !== window.top;
    if (!this.isInIframe) {
      await this.checkActiveSichernConnectIntegration();
      this.isComponentVisible = true;
    }
    const { deviceId, deviceToken } = this.$route.query
    if (deviceId && deviceToken) {
      this.loadingBiometric = true
      try {
        const {
          data: { data },
          status
        } = await this.auth.biometricLogin({ deviceId, deviceToken, status })
        this.onRequestSuccess(data)
      } catch (error) {
        this.onResponseError(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.format-img {
  max-height: 120px;
  max-width: 100%;
  vertical-align: middle;
  width: auto;
  object-fit: contain;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}
::v-deep .zt-button {
  height: 3.25rem;
}
.sichern-connect {
  border: solid 1px #6F6F6F !important;
  background: #f2f3f8;
}
.sichern-connect:hover {
  background: #e0e1e6;
}
.sichern-connect-faq {
  font-family: Roboto, sans-serif;
}
</style>